import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var BussuIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M25.2061 26.5688C28.923 26.5832 32.4533 24.9615 34.8499 22.12C36.7012 19.9387 37.7201 17.169 37.7201 14.3131C37.7345 7.53949 32.1376 2.02874 25.2348 2.02874L15.2896 2.00003C9.63535 1.98568 5.0287 6.49187 5.0287 12.0457L5 36.4566C5 36.4853 5.77495 26.5688 25.2061 26.5688Z",
    svgColor: "#116EEE"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M5 37.8628C5 42.3547 8.70254 45.9998 13.2805 45.9998H31.7358C39.1983 46.0142 43.6327 40.5895 43.6471 33.8876C43.6471 28.1903 40.4324 23.4115 34.8643 22.1199C32.4677 24.9614 28.9374 26.583 25.2205 26.5687C5.77495 26.5687 5 36.4852 5 36.4565V37.8628Z",
    svgColor: "#88B7F7"
  }));
});
BussuIcon.displayName = 'BussuIcon';
BussuIcon.defaultProps = {
  'aria-label': 'Bussu'
};
export default BussuIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/BussuIcon/index.js
// module id = 1795
// module chunks = 12